module.exports = __webpack_public_path__ + "static/media/V_pictos-02.8cec6ca2.svg";